// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"7f132bb2","513":"c156d1d9","703":"8bc3759f","787":"0399ee7d"}[chunkId] + ".chunk.js";
};